import React from "react";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";
import { phaseText, rateLimitText } from "../features/channel.utils";

// Columns of the Channel list. `start` is the row number offset of the current page.
export const getChannelColumns = (start) => [
  {
    key: "id",
    label: "S.No",
    width: "70px",
    sortable: false,
    render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span>,
  },
  {
    key: "name",
    label: "Channel",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.name || "—"}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.channel_key}</span>
      </div>
    ),
  },
  {
    key: "phase",
    label: "Sending",
    sortable: false,
    render: (row) => <Chip tone={row.phase > 1 ? "warning" : "brand"}>{phaseText(row.phase)}</Chip>,
  },
  {
    key: "supports_digest",
    label: "Supports",
    sortable: false,
    render: (row) =>
      row.supports_digest || row.supports_html ? (
        <div className="flex flex-wrap gap-1">
          {row.supports_digest && <Chip>Digest</Chip>}
          {row.supports_html && <Chip>HTML</Chip>}
        </div>
      ) : (
        <span className="text-xs text-text_muted">—</span>
      ),
  },
  {
    key: "rate_limit_per_min",
    label: "Rate Limit",
    sortable: true,
    render: (row) => <span className="whitespace-nowrap text-xs text-text_secondary">{rateLimitText(row.rate_limit_per_min)}</span>,
  },
  {
    key: "template_count",
    label: "Templates",
    sortable: false,
    render: (row) => <Chip>{row.template_count ?? 0} templates</Chip>,
  },
  {
    key: "sort_order",
    label: "Order",
    sortable: true,
    render: (row) => <span className="text-xs text-text_secondary">{row.sort_order ?? 0}</span>,
  },
  {
    key: "is_activated",
    label: "Status",
    sortable: true,
    render: (row) => <ActiveBadge active={row.is_activated} />,
  },
];
